import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import usePhotoStyle from '../../styles/PhotoStyles.jsx';

const Photo = ({
  size, src, theme, isMobile,
}) => {
  const {
    root, rootMobile, rootDark, small, medium, large, photo,
  } = usePhotoStyle();
  let photoClass;
  const isLightTheme = theme === 'light';

  if (size === 'small') {
    if (isLightTheme) {
      if (isMobile) {
        photoClass = `${root} ${rootMobile} ${small}`;
      } else {
        photoClass = `${root} ${small}`;
      }
    } else if (isMobile) {
      photoClass = `${root} ${rootMobile} ${rootDark} ${small}`;
    } else {
      photoClass = `${root} ${rootDark} ${small}`;
    }
  } else if (size === 'medium') {
    if (isLightTheme) {
      if (isMobile) {
        photoClass = `${root} ${rootMobile} ${medium}`;
      } else {
        photoClass = `${root} ${medium}`;
      }
    } else if (isMobile) {
      photoClass = `${root} ${rootMobile} ${rootDark} ${medium}`;
    } else {
      photoClass = `${root} ${rootDark} ${medium}`;
    }
  } else if (isLightTheme) {
    if (isMobile) {
      photoClass = `${root} ${rootMobile} ${large}`;
    } else {
      photoClass = `${root} ${large}`;
    }
  } else if (isMobile) {
    photoClass = `${root} ${rootMobile} ${large}`;
  } else {
    photoClass = `${root} ${rootMobile} ${rootDark} ${large}`;
  }

  const styles = {
    borderRadius: 16,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundImage: `url(${src})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    transition: 'transform .2s ease-out',
    '&:hover': {
      transform: 'scale(2)',
      zIndex: 100,
    },
    position: 'relative',
  };

  return (
    <Box className={photoClass}>
      <Box className={photo} style={styles} />
    </Box>
  );
};

Photo.propTypes = {
  size: PropTypes.string,
  src: PropTypes.string,
  theme: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Photo;
